export const SavedListsAccessStatus = {
    POWER: 'Power',
    PAST_DUE: 'PastDue',
    LAPSED: 'Lapsed',
    FREE: 'Free',
};

export const POWER_CTA_LABEL = 'GET POWER';

export const RESUME_POWER_CTA_LABEL = 'RESUME POWER';

export const SavedListSortColumn = {
    NAME: 'Name',
    PLAYERS: 'PlayerCount',
    ACTIVITY: 'RecentActivity',
};

export const SavedListOrderByRule = {
    ASCENDING: 'Ascending',
    DESCENDING: 'Descending',
};

export const SAVED_LISTS_PAGE_SIZE = 25;

export const SAVED_LISTS_PREVIEW_IMAGE_SRC = '/img/saved-lists/list-detail-preview.png';

export const SAVED_LISTS_PREVIEW_IMAGE_ALT = 'Example of a saved player list';

export const SAVED_LISTS_BENEFITS = [
    { key: 'track-rivals', text: 'Track Rivals: Keep a close eye on the players you want to beat.' },
    { key: 'follow-friends', text: 'Follow Friends: Watch your teammates\' and friends\' ratings climb.' },
    { key: 'skip-the-search', text: 'Skip the Search: Jump straight to your favorite profiles.' },
];
